import type {MaybeRef} from 'vue';

export const featureFlagKey = 'featureFlags';

export function featureFlagQueryKey(userId: MaybeRef<string | undefined>) {
    return [featureFlagKey, userId] as const;
}
